import featuresArray from "../data/features.json" with { type: "json" };
export const features = featuresArray;
function toScreamingSnakeKey(code) {
    return code.toUpperCase();
}
export const Feature = featuresArray.reduce((accumulator, code) => {
    const key = toScreamingSnakeKey(code);
    accumulator[key] = code;
    return accumulator;
}, {});
//# sourceMappingURL=features.js.map